// @flow
import React, { Fragment } from 'react';
import { isBrowser } from 'react-device-detect';
import { Link } from 'react-router-dom';
import Button from 'components/common/Button';
import MarkdownRender from 'components/common/MarkdownRender';
import ProductPrice from 'components/product/ProductPrice';
import ProductSequencesContainer from 'containers/product/ProductSequencesContainer';
import TrendingEventCards from 'containers/list/TrendingEventCards';
import Tooltip from 'react-tooltip';
import cx from 'classnames';
import { MdLock, MdChat } from 'react-icons/md';
import { resizeImage, numberWithCommas } from 'lib/common';
import cloneDeep from 'lodash/cloneDeep';

import './ProductContent.scss';
import ProductMobileShare from '../ProductMobileShare';
import ProductLikeButton from '../ProductLikeButton';
import ProductActionButtons from '../ProductActionButtons';
import ProductTags from '../ProductTags';

type Props = {
  body: string,
  theme: string,
  thumbnail: ?string,
  onChannel: void,
  price: string,
  supplier: string,
  productUrl: string,
  productPrice: string,
  displayName: string,
  tags: string,
  gradeDiscount: number,
  refreshProductData: () => Promise<boolean>,
};

const ProductContent = ({
  isPrivate,
  title,
  url,
  user,
  informCopy,
  onToggleLike,
  likes,
  liked,
  logged,
  ownProduct,
  id,
  onAskRemove,
  body,
  thumbnail,
  theme,
  price,
  supplier,
  productUrl,
  onLogin,
  productPrice,
  onChannel,
  username,
  displayName,
  currentUsername,
  tags,
  categories,
  gradeDiscount,
  badges,
  refreshProductData,
}: Props) => {
  const imgUrl = resizeImage(thumbnail, 600, 500);
  const style = {
    backgroundImage: `url(${imgUrl})`,
  };

  // /products/tags/merck

  // 깊은 복사 (리랜더링 되도라도 새로 다시 계산)
  const copyProductPrice = cloneDeep(productPrice);

  // eslint-disable-next-line no-return-assign,array-callback-return
  copyProductPrice.map(item => {
    item.price = (item.price).toFixed(0);
    item.price_vat = (item.price * 1.1).toFixed(0);
  });

  const sortCategories = categories.sort((a, b) => {
    return b.order - a.order;
  });
  const urlCategories = sortCategories.length ? sortCategories[0].url_slug : '/categories';

  return (
    <div className="ProductContent">
      <div className="mini-product-card">
        {thumbnail && (
          <Fragment>
            <div className="thumbnail" style={style} />
            <div className="separator" />
          </Fragment>
        )}
        <div className="product-info">
          <div className="header">
            <Link to={`/products/tags/${supplier}`} className="supplier-name">
              {supplier}
            </Link>
            {
              <div className="private-options">
                {isPrivate && (
                  <div className="closed-door">
                    <MdLock />
                    비공개
                  </div>
                )}
                {/* {ownProduct && <ProductActionButtons id={id} onAskRemove={onAskRemove} />} */}
              </div>
            }
          </div>
          <h1 className="title">{title}</h1>
          <div className="badges-share">
            <div className="badges">
              {badges.map(badge => (
                <div
                  className={cx('badge', {
                    'free-shipping': badge === '무료배송',
                    'ship-today': badge === '오늘출고',
                    'additional-gift': badge === '추가증정',
                    sample: badge === '샘플',
                    demo: badge === '데모',
                    'special-price': badge === '특가',
                    rental: badge === '렌탈',
                  })}
                  key={badge}
                >
                  <div className="text">{badge}</div>
                </div>
              ))}
            </div>
            <div className="share-and-likes">
              <ProductLikeButton
                onClick={onToggleLike}
                liked={liked}
                likes={likes}
                disabled={!logged}
              />
              <ProductMobileShare
                url={url}
                title={title}
                username={user.username}
                informCopy={informCopy}
              />
            </div>
          </div>
          <div className="banner">
            <Link to={'/@cacheby/banners/연구비-카드-결제-오픈-vckem7meaz'}>
              <img
                className="research-card"
                src={`${process.env.IMAGES_URL}/banner-images/cacheby/research-card.png`}
                alt="research-card-banner"
              />
            </Link>
          </div>
          {/* {price && price !== '0' ? (
            <div className="price">
              <div className="vat">VAT 포함</div>
              {numberWithCommas((price*1.1).toFixed(0))}
              <span className="price-unit">원</span>
            </div>
          ) : (
            <Fragment>
              <div className="request">견적요청</div>
              <div className="request-info">
                <strong>제품상담</strong> 버튼을 클릭하시면 해당 제품에 대해 문의하실 수 있습니다.
                <br />
                <strong>카탈로그 번호, 구매수량</strong>을 알려 주시면 빠른 상담을 진행 할 수 있습니다.
              </div>
            </Fragment>
          )} */}
          <div className="separator-x" />
          {/* <div className="sale-vendor">
            <strong>판매자: </strong>
            <Link to={`/@${username}/products`}>{displayName}</Link>
          </div> */}
          <div className="sale-brand">
            <div className="brand-text">
              <strong>브랜드: </strong>
              <Link to={`/products/tags/${supplier}`} className="supplier-name">
                {supplier}
              </Link>
            </div>
            <div className="brand-btn">
              <Button theme="outline" to={`/categories/${urlCategories}`}>
                카테고리 상품 전체보기
              </Button>
              <Button theme="outline" to={`/products/tags/${supplier}`}>
                브랜드 상품 전체보기
              </Button>
            </div>
          </div>
          <div className="separator-x" />
          <div className="buttons">
            <Button
              theme="default"
              color="blue"
              className="button"
              onClick={onChannel}
              desktop={isBrowser}
            >
              제품상담
            </Button>
            {/* <Button
              theme="default"
              color="blue"
              className="button"
              to={'/cart'}
              desktop={isBrowser}
            >
              주문하기
            </Button> */}
            {ownProduct && (
              <Button
                theme="default"
                color="green"
                className="button"
                onClick={() => window.open(productUrl)}
                desktop={isBrowser}
              >
                홈페이지
              </Button>
            )}
          </div>
          <ProductTags tags={tags} />
          <Tooltip effect="solid" className="tooltip" />
        </div>
      </div>
      <TrendingEventCards />
      {copyProductPrice.length !== 0 && (
        <ProductPrice
          logged={logged}
          currentUsername={currentUsername}
          user={user}
          onLogin={onLogin}
          productId={id}
          productPrice={copyProductPrice}
          onChannel={onChannel}
          refreshProductData={refreshProductData}
          supplier={supplier}
        />
      )}
      <ProductSequencesContainer username={username || ''} />
      {/* <div className="notification">
        <Link
          to="/products/tags/merck"
          className={cx('thumbnail-wrapper')}
          style={{
            backgroundImage: `url(https://images.cacheby.com/product-images/cacheby/b5a91fa0-8d4e-11ef-b836-0dfa0bc15903/241018-merck-1600x400.png)`,
          }}
        >
        </Link>
      </div> */}
      <div className="contents">
        <MarkdownRender body={body} theme={theme || 'github'} />
      </div>
    </div>
  );
};

export default ProductContent;



// WEBPACK FOOTER //
// ./src/components/product/ProductContent/ProductContent.js